<div data-cy="mb-submit-order-request">
  <div data-cy="mb-submit-order-request-headline">
    <span class="tw-text-lg">{{'mbcart.request' | cxTranslate}}</span>
  </div>
  <div class="tw-flex tw-justify-between">
  <ng-container *ngIf="purchaseItemsNo && purchaseItemsNo > 0">
    <div data-cy="mb-submit-order-price-items">
      <span>{{purchaseItemsNo}} {{'submitBox.itemWithS' | cxTranslate}}</span>
    </div>
    <div
      data-cy="mb-submit-order-price-value">
      <span *ngIf="totalPrice && totalPrice.formattedValue">{{totalPrice?.formattedValue}}</span>
    </div>
  </ng-container>
  <ng-container *ngIf="requestItemsNo && requestItemsNo > 0">
    <div data-cy="mb-submit-order-request-items">
      <span>{{requestItemsNo}} {{'submitBox.itemWithS' | cxTranslate}}</span>
    </div>
    <div data-cy="mb-submit-order-request-value">
      <span>{{'mbcommon.priceOnRequest' | cxTranslate}}</span>
    </div>
  </ng-container>
  </div>
</div>

